import { useBillingStore } from '~/store/billing.store';

export const billing_modules = {
  PROJECT_MANAGEMENT: {
    title: 'project_management',
    values: ['plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'project_management',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  DIGITAL_CLOCK: {
    title: 'digital_clock',
    values: ['plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'time_tracking',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  CURRENCY: {
    title: 'currency',
    values: ['plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'general',
    isDisplayedOnPricingPage: false,
    isIncludedInDetailedPricingPage: false,
  },
  TIME_LOG_BILLING: {
    title: 'time_log_billing',
    values: ['plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'time_tracking',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  TIME_LOG_CSV_EXPORT: {
    title: 'time_log_csv_export',
    values: ['plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'reporting',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  HOURLY_RATE_RULES: {
    title: 'hourly_rate_rules',
    values: ['premium', 'premium_t14'],
    category: 'time_tracking',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  MANUAL_CREATION_OF_TIME_LOGS: {
    title: 'manual_creation_of_time_logs',
    values: ['free', 'plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'time_tracking',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  CUSTOMER_MANAGEMENT: {
    title: 'customer_management',
    values: ['free', 'plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'general',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  PDF_REPORTS: {
    title: 'pdf_reports',
    values: ['free', 'plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'reporting',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  NO_WATERMARKS_ON_PDF_REPORTS: {
    title: 'no_watermarks_on_pdf_reports',
    values: ['plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'reporting',
    isDisplayedOnPricingPage: false,
    isIncludedInDetailedPricingPage: true,
  },
  DATAIMPORT: {
    title: 'dataimport',
    values: ['plus', 'plus_t14', 'premium', 'premium_t14'],
    category: 'general',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  CALENDER: {
    title: 'calender',
    values: ['premium', 'premium_t14'],
    category: 'general',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
  TEAMS: {
    title: 'teams',
    values: ['premium', 'premium_t14'],
    category: 'general',
    isDisplayedOnPricingPage: true,
    isIncludedInDetailedPricingPage: true,
  },
};

export const plans = [
  {
    name: 'free',
    buttonText: 'get_started',
  },
  {
    name: 'plus',
    buttonText: 'fourteen_days_free_trial',
  },
  {
    name: 'premium',
    buttonText: 'fourteen_days_free_trial',
  },
];

export const isAvailableForBillingPeriod = (
  availableBillingPeriods: string[]
) => {
  if (!availableBillingPeriods) {
    console.error('availableBillingPeriods is not defined');
    console.trace();
    return false;
  }

  if (availableBillingPeriods.length === 0) {
    return true;
  }

  const billingStore = useBillingStore();

  if (!billingStore.currentBillingPeriod || !billingStore.subscriptionTypes) {
    console.trace();

    if (!billingStore.currentBillingPeriod)
      console.error('undefined: billingStore.currentBillingPeriod');

    if (!billingStore.subscriptionTypes)
      console.error(
        'undefined:  billingStore.subscriptionTypes is not defined'
      );

    billingStore.getCurrentBillingPeriod();
    billingStore.getSubscriptionTypes();
    return true;
  }

  const currentSubscriptionTypes =
    billingStore.currentBillingPeriod.subscription_type;

  const subscriptionType = billingStore.subscriptionTypes.find(
    (type) =>
      currentSubscriptionTypes && type.id === currentSubscriptionTypes.id
  );

  const includes = availableBillingPeriods.includes(
    subscriptionType?.name || ''
  );

  return includes;
};
